import { skaCountryConfig } from './skaCountryConfig';

export const noop = (): null => null;

export const getSkaCountryConfig = (
  locale: string
): { partnerId: string; locale: string } | null =>
  skaCountryConfig[locale] || null;
